module.exports = {
	"title": "CSS Shapes Level 1",
	"description": "Allows geometric shapes to be set in CSS to define an area for text to flow around.",
	"spec": "http://www.w3.org/TR/css-shapes/",
	"status": "cr",
	"links": [
		{
			"url": "http://html.adobe.com/webplatform/layout/shapes/",
			"title": "Adobe demos and samples"
		},
		{
			"url": "http://html.adobe.com/webplatform/layout/shapes/browser-support/",
			"title": "CSS shapes support test by Adobe"
		},
		{
			"url": "http://alistapart.com/article/css-shapes-101",
			"title": "A List Apart article"
		},
		{
			"url": "https://bugzilla.mozilla.org/show_bug.cgi?id=1040714",
			"title": "Firefox tracking bug"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"5.5": "n"
		},
		"edge": {
			"12": "n",
			"13": "n",
			"14": "n"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n",
			"35": "n",
			"36": "n",
			"37": "n",
			"38": "n",
			"39": "n",
			"40": "n",
			"41": "n",
			"42": "n",
			"43": "n",
			"44": "n",
			"45": "n",
			"46": "n",
			"47": "n",
			"48": "n",
			"49": "n",
			"50": "n",
			"51": "n",
			"52": "n",
			"53": "n",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "n",
			"25": "n",
			"26": "n",
			"27": "n",
			"28": "n",
			"29": "n",
			"30": "n",
			"31": "n",
			"32": "n",
			"33": "n",
			"34": "n d #1",
			"35": "n d #1",
			"36": "n d #1",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "n",
			"7.1": "y x",
			"9.1": "y x",
			"TP": "y"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "n",
			"23": "n",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "y x",
			"10": "y x",
			"3.2": "n",
			"4.0-4.1": "n",
			"4.2-4.3": "n",
			"5.0-5.1": "n",
			"6.0-6.1": "n",
			"7.0-7.1": "n",
			"8.1-8.4": "y x",
			"9.0-9.2": "y x",
			"9.3": "y x"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "n",
			"4": "n",
			"53": "y",
			"2.1": "n",
			"2.2": "n",
			"2.3": "n",
			"4.1": "n",
			"4.2-4.3": "n",
			"4.4": "n",
			"4.4.3-4.4.4": "n"
		},
		"bb": {
			"7": "n",
			"10": "n"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "n",
			"37": "y",
			"11.1": "n",
			"11.5": "n",
			"12.1": "n"
		},
		"and_chr": {
			"53": "y"
		},
		"and_ff": {
			"49": "n"
		},
		"ie_mob": {
			"10": "n",
			"11": "n"
		},
		"and_uc": {
			"11": "n"
		},
		"samsung": {
			"4": "y"
		}
	},
	"notes": "",
	"notes_by_num": {
		"1": "Enabled in Chrome through the \"experimental Web Platform features\" flag in chrome://flags"
	},
	"usage_perc_y": 66.13,
	"usage_perc_a": 0,
	"ucprefix": false,
	"parent": "",
	"keywords": "circle,ellipse,polygon,inset,shape-outside,shape-inside",
	"ie_id": "shapes",
	"chrome_id": "5163890719588352",
	"firefox_id": "css-shapes",
	"webkit_id": "feature-css-shapes-level-1",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-shapes.json
 ** module id = 431
 ** module chunks = 0
 **/